import { useTranslation } from 'react-i18next'
import React from 'react'

import TagPicker from '../../../components/form/TagPicker'

const AccessPicker = props => {
  const { t } = useTranslation('editFormV2')
  const OPTIONS = [
    { label: t('private'), value: 'private' },
    { label: t('public'), value: 'public' }
  ]

  return <TagPicker options={OPTIONS} {...props} />
}

export default AccessPicker
